import React, { useContext, useEffect, useState } from 'react'
import injectStyles from 'react-jss'
import { styles } from './styles'
import SquareCheckBox from '../../../Assets/Images/icons/squareCheckBox'
import { FormContext, useFormChildLogic } from '..'
import classNames from 'classnames'
import SelectAllCheckbox from '../../../Assets/Images/icons/selectAllCheckbox'
import { DOCUMENT_FORM } from '../../../Containers/Settings/Documentation/constants'

const CitySelectPanel = ({
  classes,
  name,
  allCities,
  documentType,
  mode,
  setActive,
}) => {
  const [selectAll, setSelectAll] = useState(true)
  const [currentCities, setCurrentCities] = useState([])

  const { updateForm, value: data } = useFormChildLogic({
    name,
    initValue: [],
  })

  const context = useContext(FormContext)

  const countryCode =
    Object.keys(context.data).length > 0 && context.data.countrycode.value
      ? context.data.countrycode.value
      : null

  const documentIsActive =
    Object.keys(context.data).length > 0 &&
    context.data.active &&
    context.data.active.value === 'true'
      ? true
      : false

  const ignoredCities =
    Object.keys(documentType).length > 0 ? documentType.ignoredCities : []

  useEffect(() => {
    getCityData()
  }, [allCities, countryCode])

  const onStatusChange = () => {
    const newData = currentCities.map(city => ({
      name: city.name,
      value: city.id,
      isActive: documentIsActive
        ? !ignoredCities.includes(Number(city.id))
        : false,
    }))
    updateForm(newData)
  }

  useEffect(() => {
    if (mode === DOCUMENT_FORM.EDIT) {
      onStatusChange()
    }
  }, [currentCities])

  const getCityData = () => {
    if (allCities.length === 0 || !countryCode) return

    const currentCities = allCities
      .filter(({ country: { code } }) => code === countryCode)
      .sort((cityA, cityB) => cityB.name - cityA.name)

    const formattedList = currentCities.map(city => ({
      name: city.name,
      value: city.id,
      isActive: ignoredCities.includes(Number(city.id)) ? false : true,
    }))

    if (ignoredCities.length === currentCities.length) {
      setSelectAll(false)
    }

    if (ignoredCities.length < currentCities.length) {
      setSelectAll(true)
    }
    setCurrentCities(currentCities)

    updateForm(formattedList)
  }

  const onCityClick = ({ item, index }) => {
    const newData = data
    newData[index] = { ...item, isActive: !item.isActive }
    if (newData.some(item => item.isActive)) {
      setActive(true)
    } else {
      setActive(false)
    }
    updateForm(newData)
  }

  const onSelectAllClick = () => {
    const newData = currentCities.map(city => ({
      name: city.name,
      value: city.id,
      isActive: !selectAll,
    }))
    updateForm(newData)
    setActive(!selectAll)
    setSelectAll(!selectAll)
  }

  if (!data || data.length == 0 || !countryCode) return null
  return (
    <div className={classes.container}>
      <div className={classes.selectAllButton} onClick={onSelectAllClick}>
        <SelectAllCheckbox active={!selectAll} />
        <div className={classes.selectAllTitle}>
          {selectAll ? 'Unselect all cities' : 'Select all cities'}
        </div>
      </div>
      <div className={classes.optionsContainer}>
        {data &&
          data.map((item, index) => {
            return (
              <div
                className={classes.city}
                onClick={() => {
                  onCityClick({ item, index })
                }}
              >
                <div className={classes.checkbox}>
                  <SquareCheckBox active={item.isActive} />
                </div>
                <div className={classes.name}>{item.name}</div>
                <div
                  className={classNames({
                    [classes.chip]: true,
                    [classes.chipActive]: item.isActive,
                    [classes.chipInactive]: !item.isActive,
                  })}
                >
                  {item.isActive ? 'Active' : 'Inactive'}
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default injectStyles(styles)(CitySelectPanel)
